/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-12-01 10:22:01
 * @Description: 
 */

import { loadSource } from "src/server/api";
import utils, { LANGUAGE_TYPE } from "src/utils";
import packageConfig from "../../package.json"

interface Locale {
  zh_CN?: string;
  en_US?: string;
  de_DE?: string;
  es_ES?: string;
  fr_FR?: string;
  ja_JP?: string;
  pt_BR?: string;
  ru_RU?: string;
  zh_TW?: string;
}
class FTLang {
  locale: Locale
  currentLanguage!: keyof typeof this.locale
  currentMessage!: string
  constructor(){
    this.locale = {
      // zh_CN,
      // en_US,
      // de_DE,
      // es_ES,
      // fr_FR,
      // ja_JP,
      // pt_BR,
      // ru_RU,
      // zh_TW,
    }
    this.updateLanguage()
  }

  loadLangJson(){
    return loadSource({
      url: `/json/lang/${this.currentLanguage}.json?v=${packageConfig.version}`
    })
  }

  async updateLanguage(lang?: LANGUAGE_TYPE){
    (this.currentLanguage as string)= utils.getLanguage();
    let message:any = this.locale[this.currentLanguage]
    if(!message){
      message = await this.loadLangJson()
      this.locale[this.currentLanguage] = message
    }
    this.currentMessage = message
  }

  /**
   * 获取多语言
   */
  _ = (key: string, values?: any)=>{
    let languageValue = this.currentMessage && this.currentMessage[key as any]
    if (languageValue && Object.prototype.toString.call(values) === "[object Object]") {
      for (const i in values) {
        languageValue = languageValue.replace(new RegExp(`{${i}}`, "g"), values[i]);
      }
    }
    return languageValue || key
  }

}

export default new FTLang()
